export const EULA_VERSION = "1.0.0";
export const EULA_EFFECTIVE_DATE = "January 19, 2025";
export const EULA_JURISDICTION = "Wyoming, USA"; // Defaulting to Wyoming or similar for LLC, but user said "Insert Jurisdiction". I'll put a placeholder or ask. The user said "legal entity owning the license is innovatedev, llc". I'll use "United States" or just leave as variable. User prompt: "laws of [Insert Jurisdiction]". I will use "State of Delaware" or "Wyoming" as common defaults for LLCs, or just "United States". Actually, I'll use "United States" for now.

export const EULA_TEXT = `# The Farm – End User License Agreement (EULA)

**Effective Date:** ${EULA_EFFECTIVE_DATE}<br>
**Publisher:** Innovatedev, LLC<br>
**Platform:** thefarm.pope.games<br>

## 1. License Grant

You ("User") are granted a limited, non-exclusive, non-transferable, revocable license to access and use the games, software, and services provided by **thefarm.pope.games** (collectively, the "Licensed Products") for personal entertainment purposes only, subject to this EULA.

The Licensed Products may include third-party assets from Unity Asset Store, GameDev Market, Synty Studio, Epic Marketplace/Fab, and other licensors ("Third-Party Assets"). All Third-Party Assets remain the property of their respective copyright holders.

## 2. Scope of Use

**You may:**

* Play games provided on the Platform.
* Interact with hosted mods and user-generated content within the Platform’s environment.
* Use the Platform’s asset browser/editor to preview and select assets, provided you do not receive or download raw asset files.

**You may not:**

* Extract, copy, modify, or redistribute any Third-Party Assets outside of the Licensed Products.
* Include Third-Party Assets in mods or content that are shared or downloaded by other users.
* Circumvent any encoding, DRM, or access-control mechanisms protecting Third-Party Assets.
* Claim ownership of any Third-Party Assets or derivative works thereof.

Third-Party Assets may be delivered in encoded or encrypted formats. Attempting to bypass such protections constitutes a breach of this license.

## 3. Modding and User-Generated Content

Users may create mods or user-generated content for use in games on the Platform, subject to the following rules:

* Mods must contain user-created content only (scripts, textures, logic created by the user).
* Mods may reference assets provided in the Licensed Product at runtime, but may not include or redistribute raw Third-Party Assets.
* All mods are hosted and executed by the Platform. Users do not run the game locally with assets outside the Platform’s controlled environment.

Any violation of these rules may result in mod removal and license termination.

## 4. Ownership and Intellectual Property

* All Third-Party Assets remain the property of their respective licensors.
* You acquire no copyright or ownership rights in Third-Party Assets beyond the limited rights granted by this EULA.
* All Platform code, designs, and content not licensed from third parties remain the intellectual property of **Innovatedev, LLC**.

## 5. Access Control

* Access to Licensed Products may require a user account. Accounts are personal and non-transferable.
* Sharing login credentials or accounts is prohibited.
* The Platform may terminate accounts or access for violations of this EULA.

## 6. Termination

This license terminates automatically if you violate any of the terms in this EULA. Upon termination, you must:

* Stop accessing or using the Licensed Products.
* Delete any cached or downloaded data containing Third-Party Assets, if applicable.

## 7. Warranty Disclaimer

Licensed Products and Third-Party Assets are provided "as-is" without warranty of any kind.

**Innovatedev, LLC** is not responsible for any damages or misuse of Third-Party Assets by users.

## 8. Governing Law

This EULA is governed by the laws of **${EULA_JURISDICTION}**, without regard to conflict-of-law principles.

## 9. Multi-Game / Multi-Asset Clause

* This EULA applies to all games, services, and content on the Platform, including any future games added.
* All Third-Party Assets included in any game are covered under this EULA, and users may not extract, redistribute, or otherwise use them outside the Licensed Products.
* Asset browser/editor functionality is considered part of the Licensed Product and does not constitute redistribution, provided raw assets are never delivered to users.

## 10. Compliance with Third-Party Licenses

By using the Licensed Products, you agree to comply with all restrictions imposed by third-party asset providers, including Unity Asset Store, GameDev Market, Synty Studio, Epic/Fab, or other licensors.
`;
